u.Bind = class extends u.Consumer {
    /**
     *
     */
    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.bindTo = this.getAttribute('bind-to');
        this.$storage.$listen(this.bindTo, this.$onChange.bind(this));
    }

    $onChange(value) {
        /**
         * 
         */
        this.textContent = value;
    }
};

u.Bind.register('u-bind');
